import MainConnection from "./MainConnection";

export default {
  requestBusinessUnitList: async function() {
    try {
      const requestURL = "/business_unit/list";
      const response = await MainConnection.request().get(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestCreateBusinessUnit: async function(parmas) {
    try {
      const requestURL = "/business_unit/save";
      const response = await MainConnection.request().post(requestURL, parmas);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestUpdateBusinessUnit: async function(bu_id, parmas) {
    try {
      const requestURL = "/business_unit/" + bu_id;
      const response = await MainConnection.request().patch(requestURL, parmas);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  },
  requestRemoveBusinessUnit: async function(bu_id) {
    try {
      const requestURL = "/business_unit/" + bu_id;
      const response = await MainConnection.request().delete(requestURL);
      return response.data;
    } catch (error) {
      MainConnection.errorMessage(error);
    }
  }
};
